import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cameraInput", "fileInput"]
  declare readonly cameraInputTarget: HTMLInputElement
  declare readonly fileInputTarget: HTMLInputElement


  connect() {
    this.checkNative()
  }

  checkNative() {
    // If we detect the specific user agent or bridge presence, we can toggle visibility
    const isNative = navigator.userAgent.includes("Pacta-Native")
    
    if (isNative) {
      this.element.querySelectorAll(".bridge-only").forEach(el => el.classList.remove("hidden"))
      this.element.querySelectorAll(".web-only").forEach(el => el.classList.add("hidden"))
    }
  }

  show() {
    this.element.classList.remove("hidden")
  }

  hide() {
    this.element.classList.add("hidden")
  }

  // Action for "Scan with Camera" button
  triggerCamera() {
    this.cameraInputTarget.click()
  }

  // Action for "Upload Image" button
  triggerFile() {
    this.fileInputTarget.click()
  }
}
